export type LikableContentObject = LikableCamelCase | LikableSnakeCase;
type LikableCamelCase = { liked: boolean; likesCount: number };

// eslint-disable-next-line @typescript-eslint/naming-convention -- TODO: Needs to be fixed later
type LikableSnakeCase = { liked: boolean; likes_count: number };

export const patchContentObjectLike = <T extends LikableContentObject>(item: T, action: 'like' | 'unlike'): T => {
  const delta = action === 'like' ? 1 : -1;

  if ('likesCount' in item) {
    return { ...item, liked: !item.liked, likesCount: item.likesCount + delta };
  }

  return { ...item, liked: !item.liked, likes_count: item.likes_count + delta };
};
